<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{
                name: 'RegisterAdminCompany',
                params: {
                  id: $route.params.id,
                  slug: $route.params.slug,
                },
              }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasCompanyAdmins">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="admin in companyAdmins"
              :key="admin.id"
            >
              <CardCompanyAdmin :admin="admin" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardCompanyAdmin from "@/views/Company/components/CardCompanyAdmin";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Empresas",
          routerName: "ListCompanies",
        },
        {
          name: "Menu Empresa",
          routerName: "MenuCompany",
        },
        {
          name: "Administradores",
          routerName: "ListAdminsCompany",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("Company", ["companyAdmins"]),
    hasCompanyAdmins() {
      return (
        this.companyAdmins &&
        Array.isArray(this.companyAdmins) &&
        this.companyAdmins.length > 0
      );
    },
    hasParams() {
      return this.$route.params && Object.keys(this.$route.params).length > 0;
    },
  },
  components: {
    Breadcrumb,
    CardCompanyAdmin,
  },
  methods: {
    ...mapActions("Company", ["consultCompanyAdmins", "setDataDefault"]),
    handleDataBreadcrumb() {
      this.links[2].name = `Menu - ${this.$route.params.slug}`;
      this.links[2].routerParams = {
        params: {
          ...this.$route.params,
        },
      };
    },
  },
  async mounted() {
    if (this.hasParams) {
      const payload = { id: this.$route.params.id };
      await this.consultCompanyAdmins(payload);
      this.handleDataBreadcrumb();
    }
  },
};
</script>
